import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from 'app/queryClient'
import Timeline from 'components/Common/Timeline/Timeline'
import { confirmAlert } from 'react-confirm-alert'

type JobNumberAuditProps = {
  jobNumber: number
  bookingId: number
  fixedPriceDisplay?: boolean
  displayVATPrice?: boolean
}

const JobNumberAudit = ({ jobNumber, bookingId }: JobNumberAuditProps) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <QueryClientProvider client={queryClient}>
          <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{`Job Reference Audit Trail`}</DialogTitle>
            <DialogContent>
              <Timeline vehicleId={jobNumber} bookingId={bookingId} />
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </QueryClientProvider>
      )
    },
  })
}

export default JobNumberAudit
